<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input v-model="vendorType.label" label="Name" style="width:470px"></base-input>
        </div>
      </div>
      <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Select, Option, Form } from "element-ui";
export default {
  data: () => {
    return {};
  },

  computed: {
    ...mapState("vendorType", ["vendorType"])
  },

  methods: {
    ...mapActions({
      saveVendorType: "vendorType/saveVendorType",
      getVendorTypeList: "vendorType/getVendorTypeList",
      updateVendorType: "vendorType/updateVendorType"
    }),

    onSubmit() {
      if (this.vendorType.vendorTypeId) {
        this.updateVendorType().then(res => {
          this.$notify({
            message: "Vendor Type Updated Succesfully!",
            type: "success",
            title: "Succes"
          });
          this.getVendorTypeList();
          this.$emit("close");
        });
      } else {
        this.saveVendorType().then(res => {
          this.$notify({
            message: "Vendor Type Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getVendorTypeList();
          this.$emit("close");
        });
      }
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form
  }
};
</script>